/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICommerceAssistantViewProps } from './commerce-assistant';
import { assistantStyles } from './commerce-assistant.styles';

/**
 * CommerceAssistantView component.
 * @extends {React.PureComponent<ICommerceAssistantViewProps>}
 */
export const CommerceAssistantView: React.FC<ICommerceAssistantViewProps> = props => {
    const { moduleProps, isOpen, heading, launcher, panelTitle, closeButton, transcript, composer, alert } = props;

    return (
        <Module {...moduleProps}>
            {heading}
            {launcher}
            {isOpen ? (
                <div className='ms-commerce-assistant__panel' style={assistantStyles.panel} role='dialog' aria-modal='false'>
                    <div className='ms-commerce-assistant__panel-header' style={assistantStyles.panelHeader}>
                        {panelTitle}
                        {closeButton}
                    </div>
                    {transcript}
                    {alert}
                    {composer}
                </div>
            ) : null}
        </Module>
    );
};

export default CommerceAssistantView;
